<template>
    <v-flex xs12 sm12 md12 lg12 xl8>
        <v-card flat class="premium-box text-xs-center">
            <v-card-text class="pa-3">
                <h3>Completed your FDCA Police Check?</h3>
                <img src="../../assets/police_check_logo.png" height="50">
                <p class="mb-1">Claim $15 off your policy with your FDCA Polic Checks promo code</p>
                <v-layout id="premium-container" row wrap align-center justify-center>
                    <v-flex xs10 sm6 md6 lg6 xl6>
                            <v-text-field
                        v-model="fdca_code"
                        label="Enter code"
                        single-line
                        outline
                        class=""
                        id="fdca_code"
                    ></v-text-field>
                    </v-flex>
                </v-layout>
                <p class="mb-0"><a href="https://fdcapolichecks.com.au" target="_blank">fdcapolichecks.com.au</a></p>
            </v-card-text>
        </v-card>
    </v-flex>
</div>
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import Globals from '@/assets/scripts/global-functions.js'
import IconInformation from '@/components/icons/information.vue'

export default {
    name: "PremiumPoliceChecked",
    components: {
        IconBase,
        IconArrowRight,
        IconArrowBack,
        IconStarCheck,
        Globals,
        IconInformation
    },
    props: {
    },
    data () {
        return {

        }
    },
    mounted() {
        
        
    },
    methods: {

        
    }
}
</script>

<style lang="scss" scoped>
#premium-container {
    .premium-box {
        border: 1px solid #e0dede;
        border-radius: 5px;
        .v-card__text {
            border-bottom: 1px solid #e0dede;
        }
        .v-card__text:last-child {
            border-bottom: none;
        }
    }
}

.insurance-process-step h3{
    margin-bottom: 0.6rem;
    color: #0A2435;
    font-weight: 600;
}


</style>
